import React from 'react';
import ProjectPage from '../../components/projects/ProjectPage';
import signatureData from '../../data/projects/signature.js';

function Signature() {
  return <ProjectPage projectData={signatureData} />;
}

export default Signature;

